import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Popover } from '@mui/material';
import { useId, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { VARIABLE_NAME_TO_COLUMN } from '../constantsArticleExcel';

const IssuesPopover = ({ issues, excelRow, excelSheet }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();

  if (!issues?.length) return null;

  return (
    <>
      <style>{`@keyframes issue-blink { 0%,100%{opacity:1} 50%{opacity:0.2} }`}</style>
      <span
        data-tooltip-id={`issue-tooltip-${id}`}
        data-tooltip-content="Haz clic para ver los problemas"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl((prev) => (prev ? null : e.currentTarget));
        }}
        style={{
          width: '3rem',
          minWidth: '3rem',
          maxWidth: '3rem',
          cursor: 'pointer',
          backgroundColor: '#c020204c',
          padding: '0.2rem',
          borderRadius: '4px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontStyle: 'italic',
          color: '#c50202',
        }}
      >
        ({issues.length})
        <ReportProblemOutlinedIcon
          style={{
            color: '#ff0707',
            width: '1.2rem',
            height: '1.2rem',
            minWidth: '1.2rem',
            maxWidth: '1.2rem',
            aspectRatio: '1',
            animation: 'issue-blink 1s ease-in-out infinite',
          }}
        />
      </span>
      <Popover
        id={`issues-popover-${id}`}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <div className="diff-popover-container" style={{ maxHeight: '320px', overflowY: 'auto', minWidth: '260px' }}>
          <p>Problemas ({issues.length})</p>
          {excelSheet && excelRow && (
            <p style={{ fontSize: '0.75rem', color: '#888', margin: '0 0 0.4rem 0' }}>
              Pestaña: <strong>{excelSheet}</strong> · Fila: <strong>{excelRow}</strong>
            </p>
          )}
          <div>
            {issues.map((issue, idx) => (
              <p key={idx}>
                {issue?.field && (
                  <strong style={{ marginRight: '0.3rem', color: '#c50202' }}>
                    [{VARIABLE_NAME_TO_COLUMN[issue.field] ?? issue.field}]
                  </strong>
                )}
                {issue?.message ?? issue}
              </p>
            ))}
          </div>
        </div>
      </Popover>
      <Tooltip id={`issue-tooltip-${id}`} place="top" />
    </>
  );
};

export default IssuesPopover;
